import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import { ReadSubscribableOrganisationUnitTreeResponse } from 'features/care-connect-settings/domain/models/subscribable-organisation-unit-tree-response';

const organisationUnitBaseUrl = '/api/v1/OrganisationUnit';

export enum SubscribableOrganisationUnitTreeQueryPaths {
  ReadSubscribableOrganisationUnitTree = 'ReadSubscribableOrganisationUnitTree',
}

const readSubscribableOrganisationUnitTree = async (
  axiosInstance: AxiosInstance,
): Promise<ReadSubscribableOrganisationUnitTreeResponse> => {
  const response = await axiosInstance.get(
    `${organisationUnitBaseUrl}/${SubscribableOrganisationUnitTreeQueryPaths.ReadSubscribableOrganisationUnitTree}`,
  );
  return response.data;
};

export const useReadSubscribableOrganisationUnitTree = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [SubscribableOrganisationUnitTreeQueryPaths.ReadSubscribableOrganisationUnitTree],
    queryFn: () => readSubscribableOrganisationUnitTree(authenticatedInstance),
  });
};
